import { CircularProgress, EmptyState, InfiniteScrollTrigger, Stack } from '@all-manager/design-system-v2';
import { useGetPendingSubTopicList } from '../../api/useGetPendingSubTopicList';
import NoPendingSubjectIcon from '../../assets/no-pending-subject.svg?react';
import PendingSubTopicCard from './PendingSubTopicCard';
import { flattenUniquePages } from '../../../../utils/pagination';

export default function PendingSubTopicList() {
  const { data, isLoading, hasNextPage, isFetchingNextPage, isFetchNextPageError, fetchNextPage } = useGetPendingSubTopicList();
  const subTopics = flattenUniquePages(data?.pages, (subTopic) => subTopic.id ?? '');

  if (isLoading) {
    return (
      <Stack alignItems="center">
        <CircularProgress size="large" aria-label="Chargement des sujets en cours" />
      </Stack>
    );
  }

  if (subTopics.length === 0) {
    return (
      <EmptyState
        title="Aucun sujet en cours"
        subtitle="Tout est à jour !"
        image={<NoPendingSubjectIcon />}
      />
    );
  }

  return (
    <Stack spacing={1}>
      {subTopics.map((subTopic) => {
        if (!subTopic.id) return null;

        return (
          <PendingSubTopicCard
            key={subTopic.id}
            subTopic={subTopic}
          />
        );
      })}
      <InfiniteScrollTrigger
        hasMore={hasNextPage}
        isLoading={isFetchingNextPage}
        isError={isFetchNextPageError}
        onLoadMore={fetchNextPage}
        label="Voir plus de sujets"
      />
    </Stack>
  );
}
